import { useTheme } from '@xstyled/styled-components';
import { useMemo } from 'react';

export function useColor(correct?: boolean) {
  const theme: any = useTheme();
  return useMemo(() => {
    switch (correct) {
      case true:
        return theme?.colors?.greenDark;
      case false:
        return theme?.colors?.redDark;
      default:
        return 'transparent';
    }
  }, [correct]);
}
